import { ClientAction } from "store/actions";
import { IFolder } from "store/types";
import { ClientDetail } from "store/types/client";

import { IAction } from "../..";
import { reducer } from "../index";

reducer.createHandler(ClientAction.FetchClientSuccess, (state, { payload }: IAction<ClientDetail>) => ({
  ...state,
  clientModule: {
    ...state.clientModule,
    client: payload
  }
}));

reducer.createHandler(ClientAction.ClearClient, (state) => ({
  ...state,
  clientModule: {
    ...state.clientModule,
    client: null,
    workspaceFolders: {}
  }
}));

reducer.createHandler(ClientAction.SetWorkspaceFolders, (state, { payload }: IAction<Record<number, IFolder>>) => ({
  ...state,
  clientModule: {
    ...state.clientModule,
    workspaceFolders: payload
  }
}));

reducer.createHandler(
  ClientAction.PatchWorkspaceFolder,
  (state, { payload }: IAction<{ id: number; patch: Partial<IFolder> }>) => {
    const existing = state.clientModule.workspaceFolders[payload.id];
    if (!existing) return state;
    return {
      ...state,
      clientModule: {
        ...state.clientModule,
        workspaceFolders: {
          ...state.clientModule.workspaceFolders,
          [payload.id]: { ...existing, ...payload.patch }
        }
      }
    };
  }
);

reducer.createHandler(ClientAction.SetClientCharBarOpen, (state, { payload }: IAction<boolean>) => ({
  ...state,
  clientModule: {
    ...state.clientModule,
    isClientCharBarOpen: payload
  }
}));
